import { render } from "./ConviteGrupoWhatts.vue?vue&type=template&id=fa05fc94&scoped=true"
const script = {}

import "./ConviteGrupoWhatts.vue?vue&type=style&index=0&id=fa05fc94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa05fc94"]])

export default __exports__